/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  FailureResponseResponse,
  GetCashDeclarationHistoryParams,
  GetCashDeclarationHistoryResponseResponse,
  NotFoundResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get cash declaration history records of all accounting locations
 * @summary Get cash declaration history records of all accounting locations history
 */
export const getCashDeclarationHistory = (
  params?: GetCashDeclarationHistoryParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetCashDeclarationHistoryResponseResponse>({
    url: `/BboCashManagementService/v1/cash-declaration/history`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetCashDeclarationHistoryQueryKey = (params?: GetCashDeclarationHistoryParams) => {
  return [
    `/BboCashManagementService/v1/cash-declaration/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCashDeclarationHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCashDeclarationHistory>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashDeclarationHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashDeclarationHistory>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCashDeclarationHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCashDeclarationHistory>>> = ({
    signal,
  }) => getCashDeclarationHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCashDeclarationHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCashDeclarationHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCashDeclarationHistory>>
>;
export type GetCashDeclarationHistoryQueryError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Get cash declaration history records of all accounting locations history
 */
export const useGetCashDeclarationHistory = <
  TData = Awaited<ReturnType<typeof getCashDeclarationHistory>>,
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
>(
  params?: GetCashDeclarationHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCashDeclarationHistory>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetCashDeclarationHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
